import { Button, Label, TextInput } from 'flowbite-react';
import { useNavigate } from 'react-router-dom';
import { useForm, Controller } from 'react-hook-form';
import { useMutationData } from '../../../hooks/useMutationData';
import { Loading } from '../../../components/Loading/Loading';
import { useContext } from 'react';
import { ThemeContext } from '../../../components/ThemeContext/ThemeContext';
import { RolInterface } from '../../../interfaces/RolInterface';

// Define la interfaz para los datos del formulario usando RolInterface
interface RolForm extends Pick<RolInterface, 'nombre'> {}

export const RolCrearScreen = () => {
  const { control, handleSubmit } = useForm<RolForm>();
  const mutateRol = useMutationData({ url: '/rol' });
  const navigate = useNavigate();
  const { isDarkMode } = useContext(ThemeContext);

  const onSubmit = (data: RolForm) => {
    mutateRol.mutate(
      {
        data: data,
        tipo: 'post',
      },
      {
        onSuccess: () => navigate('/rol'),
      }
    );
  };

  if (mutateRol.isPending) {
    return <Loading />;
  }

  return (
    <div className={`min-h-screen p-6 ${isDarkMode ? 'bg-gray-800 text-white' : 'bg-white text-black'}`}>
      <div className={`max-w-4xl mx-auto p-6 rounded-lg shadow-lg space-y-6 ${isDarkMode ? 'bg-gray-700' : 'bg-white'}`}>
        <div className={`bg-gradient-to-r from-blue-400 to-blue-600 p-6 text-white rounded-t-lg`}>
          <h2 className="text-3xl font-bold text-center">Crear un nuevo Rol</h2>
        </div>
        <form onSubmit={handleSubmit(onSubmit)} className="space-y-6">
          <div className="space-y-2">
            <Label htmlFor="nombre" value="Nombre del Rol" />
            <Controller
              name="nombre"
              control={control}
              defaultValue=""
              rules={{
                required: 'Se requiere un nombre para el rol',
                maxLength: { value: 32, message: 'El nombre debe tener menos de 32 caracteres' },
              }}
              render={({ field, fieldState }) => (
                <TextInput
                  id="nombre"
                  placeholder="Nombre del rol..."
                  {...field}
                  color={fieldState.error ? 'failure' : 'default'}
                  helperText={fieldState.error?.message}
                  className={isDarkMode ? 'bg-gray-700 text-black' : 'bg-white text-black'}
                />
              )}
            />
          </div>

          <div className="flex space-x-4 pt-4">
            <Button
              type="submit"
              className={`w-full ${isDarkMode ? 'bg-blue-600 hover:bg-blue-700' : 'bg-blue-600 hover:bg-blue-700'} text-white`}
            >
              Crear
            </Button>
            <Button
              type="button"
              onClick={() => navigate('/rol')}
              className={`w-full ${isDarkMode ? 'bg-red-600 hover:bg-red-700' : 'bg-red-500 hover:bg-red-600'} text-white`}
            >
              Cancelar
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};